import { c as _c } from "react/compiler-runtime";
import { EntityPlacementCtaTypeEnum } from '@cc-shopping/contracts/cross-site/marketplace/enums';
import { CTASearchParams } from '@cc-shopping/platform-analytics/lib/ctaSearchParams';
import { CtaLink } from 'src/features/product-card/CTA/CtaLink';
import { useCreditCardCompareOfferContext } from '../OfferContext';
import { ContentText } from './components/ContentText';
import { OngoingAPRContainer } from './OngoingAPR.container';
export function OngoingAPR() {
  const $ = _c(11);
  const {
    analytics,
    offer: t0
  } = useCreditCardCompareOfferContext();
  const {
    aprDisplayList,
    cta: t1,
    termsAndFeesLink,
    name,
    displayName
  } = t0;
  const {
    type
  } = t1;
  let t2;
  if ($[0] !== aprDisplayList) {
    t2 = aprDisplayList.map(_temp);
    $[0] = aprDisplayList;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== analytics || $[3] !== displayName || $[4] !== name || $[5] !== termsAndFeesLink || $[6] !== type) {
    t3 = termsAndFeesLink && type === EntityPlacementCtaTypeEnum.ApplyNow && <CtaLink href={termsAndFeesLink} analytics={{
      ...analytics,
      section: {
        ...analytics.section,
        name: "cc_compare_grid",
        position: 0
      }
    }} finishType={analytics.finishType} type="RATES_AND_FEES_TEXT" target="_blank" rel="nofollow" parameterActions={[CTASearchParams.MONETIZING, CTASearchParams.SHOPPING_FINISH]} sx={{
      fontSize: {
        xs: "0.75rem",
        md: "1rem"
      }
    }} aria-label={`View rates and fees for ${displayName || name}}`}>View Rates and Fees</CtaLink>;
    $[2] = analytics;
    $[3] = displayName;
    $[4] = name;
    $[5] = termsAndFeesLink;
    $[6] = type;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <OngoingAPRContainer>{t2}{t3}</OngoingAPRContainer>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function _temp(ongoingAPRItem, ongoingAPRItemIndex) {
  return <ContentText key={ongoingAPRItemIndex}>{ongoingAPRItem}</ContentText>;
}